import { MuiMenuItem, MuiMenu, MuiTooltip, MuiSelect, MuiPaper, MuiCheckbox, MuiChip, MuiRadio } from './components'
import { type ThemeOptions } from '@mui/material/styles'

// This is the global theme options for the application
export const themeOptions: ThemeOptions = {
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  components: {
    MuiMenuItem,
    MuiTooltip,
    MuiSelect,
    MuiPaper,
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: 'none',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'none',
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingBlock: 12,
        },
      },
      defaultProps: {
        size: 'small',
      },
    },
    MuiIcon: {
      defaultProps: {
        fontSize: 'small',
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontFamily: 'inherit',
          fontWeight: 600,
        },
        sizeSmall: {
          padding: '4px 10px',
        },
        outlinedSecondary: {
          borderColor: '#D5D7DA',
        },
      },
    },
    MuiInput: {
      defaultProps: {
        size: 'small',
        sx: { borderRadius: 8, borderColor: '#D5D7DA' },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        sx: { borderRadius: 8, borderColor: '#D5D7DA' },
      },
    },
    MuiGrid: {
      defaultProps: {
        spacing: 2,
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        sx: { borderColor: '#D5D7DA' },
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
        sizeSmall: {
          '& .MuiOutlinedInput-input': {
            padding: '6px 10px',
          },
          '& .MuiInputLabel-root': {
            backgroundColor: 'red',
          },
          '& .MuiInputBase-inputMultiline': {
            padding: '0',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.MuiInputLabel-sizeSmall': {
            transform: 'translate(14px, 4px) scale(1)', // <-- tu przesuwasz labelkę w dół/górę
          },
        },
        shrink: {
          '&.MuiInputLabel-sizeSmall': {
            transform: 'translate(14px, -12px) scale(0.75)', // <-- po "uniesieniu"
          },
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: ({ theme }) => ({
          ':hover': {
            backgroundColor: theme.palette.background.default,
          },
        }),
      },
    },
    MuiChip,
    MuiCheckbox,
    MuiRadio,
    MuiMenu,
  },
}
